
namespace GeniuzPOS.PosShift {

    @Serenity.Decorators.registerClass()
    export class PsVatRefundPrintingParaGrid extends Serenity.EntityGrid<PsVatRefundPrintingParaRow, any> {
        protected getColumnsKey() { return PsVatRefundPrintingParaColumns.columnsKey; }
        protected getDialogType() { return PsVatRefundPrintingParaDialog; }
        protected getIdProperty() { return PsVatRefundPrintingParaRow.idProperty; }
        protected getInsertPermission() { return PsVatRefundPrintingParaRow.insertPermission; }
        protected getLocalTextPrefix() { return PsVatRefundPrintingParaRow.localTextPrefix; }
        protected getService() { return PsVatRefundPrintingParaService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}